import React from 'react'
import { graphql } from 'gatsby'
import CaseStudies from './_case-studies'

const CaseStudiesPage = (props) => <CaseStudies {...props} />

export const queryTeam = graphql`
  query {
    header: prismicHeader {
      ...prismicHeaderFragment
    }
    page: allPrismicCasestudy {
      nodes {
        uid
        ...prismicCasestudyFragment
      }
    }
    footer: prismicFooter {
      ...prismicFooterFragment
    }
  }
`

export default CaseStudiesPage
